import { createContext } from 'react';
import GlobalPresenceMembersStore from './GlobalPresenceStore';

export const GlobalPresenceContext = createContext(new GlobalPresenceMembersStore());
